import { VideoMeetingControls } from "./VideoMeetingControls";
import { VideoMeetingActiveTab } from "../../videoMeeting.types";
import { useChatUnreadCount } from "@core/features/chat";
import { useFetchUserCircles } from "@core/features/circle";
import { useVideoUI, usePlatformStore } from "@platform/store";

export function VideoMeetingControlsContainer() {
  const { isSidebarOpen, openSidebar, closeSidebar } = useVideoUI();
  const unreadCount = useChatUnreadCount();
  const user = usePlatformStore((s) => s.user);
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;

  const handleMenuClick = (tab: VideoMeetingActiveTab) => {
    openSidebar(tab);
  };

  const handleCloseSidebar = () => {
    closeSidebar();
  };

  return (
    <VideoMeetingControls
      onMenuClick={handleMenuClick}
      closeSidebar={handleCloseSidebar}
      isSidebarOpen={isSidebarOpen}
      unreadCount={unreadCount}
      userCircles={userCircles}
    />
  );
}
